import request from '@/utils/request'

// 分页查询某个业务实体的操作日志列表
export function listOperateLog(query) {
  return request({
    url: '/opLog/listOperateLog',
    method: 'get',
    params: query
  })
}
